import React, { useState } from 'react';

export default function Calendar({
  onDateSelect,
  availableDates = [],
  onMonthChange,
  minDate,
  getDayClassName,
  initialDate = new Date() // add default
}) {
  const today = new Date();
  const [viewDate, setViewDate] = useState(initialDate);

  const year = viewDate.getFullYear();
  const month = viewDate.getMonth();

  // Get first day of month (0=Sun, 1=Mon, ...)
  const firstDay = new Date(year, month, 1).getDay();
  // Get number of days in month
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  // Build calendar grid
  const days = [];
  for (let i = 0; i < firstDay; i++) {
    days.push(<div key={`empty-${i}`} className="calendar-day empty"></div>);
  }
  for (let d = 1; d <= daysInMonth; d++) {
    const dateObj = new Date(year, month, d);
    const isToday =
      d === today.getDate() &&
      month === today.getMonth() &&
      year === today.getFullYear();

    const isDisabled = minDate && dateObj < minDate;
    const extraClass =
      typeof getDayClassName === 'function'
        ? getDayClassName(dateObj)
        : '';

    days.push(
      <button
        key={d}
        className={[
          'calendar-day',
          isToday ? 'today' : '',
          extraClass
        ].filter(Boolean).join(' ')}
        onClick={() => {
          if (!isDisabled) onDateSelect(dateObj);
        }}
        style={{
          background: isToday ? '#e6f4fa' : '#fff',
          border: '1px solid #ddd',
          borderRadius: 2,
          margin: 0,                // use grid gap instead of margins
          width: 32,
          height: 32,
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: isDisabled ? 'not-allowed' : 'pointer',
          fontWeight: isToday ? 700 : 500,
          color: isDisabled ? '#878484ff' : '#020f2aff',
          opacity: isDisabled ? 0.9 : 1
        }}
        disabled={isDisabled}
      >
        {d}
      </button>
    );
  }

  // Month navigation
  const handlePrevMonth = () => {
    setViewDate(new Date(year, month - 1, 1));
  };
  const handleNextMonth = () => {
    setViewDate(new Date(year, month + 1, 1));
  };

  // Month names
  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  // Weekday names
  const weekdayNames = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

  return (
    <div
      style={{
        background: '#fff',
        borderRadius: 12,
        boxShadow: '0 2px 8px rgba(40,44,52,0.08)',
        padding: 16,
        width: 260,
        boxSizing: 'border-box',
        textAlign: 'center'
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 8,
          whiteSpace: "nowrap"
        }}
      >
        <button onClick={handlePrevMonth} style={{ background: "none", border: "none", fontSize: 18, cursor: "pointer" }}>&lt;</button>
        <span style={{ fontWeight: 600, fontSize: "1.1rem", whiteSpace: "nowrap" }}>
          {viewDate.toLocaleString('default', { month: 'long' })} {year}
        </span>
        <button onClick={handleNextMonth} style={{ background: "none", border: "none", fontSize: 18, cursor: "pointer" }}>&gt;</button>
      </div>

      {/* Replace the two separate grids with a single unified grid to keep perfect alignment */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(7, 1fr)',
          columnGap: 2,
          rowGap: 2,
          justifyItems: 'center',
          alignItems: 'center',
          whiteSpace: 'nowrap'
        }}
      >
        {/* Weekday header row (always aligns with days below) */}
        {weekdayNames.map(wd => (
          <div
            key={`hd-${wd}`}
            style={{ fontWeight: 600, color: '#4fa3c7', fontSize: 13, textAlign: 'center' }}
          >
            {wd}
          </div>
        ))}

        {/* Days (including leading empty cells already in `days`) */}
        {days}
      </div>

      <style>{`
        /* Ensure leading empty cells match button size so rows align with headers */
        .calendar-day.empty {
          width: 32px;
          height: 32px;
          box-sizing: border-box;
          border: 1px solid transparent;
          border-radius: 2px;
        }
      `}</style>
    </div>
  );
}